import { RotateRightOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import React from 'react';
import { Components } from '@fasstech/flexiget';

const SelectOrientation = ({ defaultOrientation, changeOrientation, currentOrientation, hasLandscapeWidget, disabled }) => {
  const isDisabled = disabled || (hasLandscapeWidget && currentOrientation === 'landscape');

  return (
    <>
      <Components.Tooltip title="Mise en page" className="!inline-flex !flex-row">
        <RotateRightOutlined
          className="flex relative text-sm text-center h-32px px-3 items-center text-black opacity-85 bg-gray-50 border border-solid border-gray-300 !border-r-0 rounded-l transition-all duration-300"
        />

        <Select
          className="select-prefix w-150px h-30px text-left bg-transparent border-0 outline-none transition-all duration-300 appearance-none"
          defaultValue={defaultOrientation}
          onChange={changeOrientation}
          disabled={isDisabled}
        >
          <Select.Option value="portrait">Portrait</Select.Option>
          <Select.Option value="landscape">Paysage</Select.Option>
        </Select>
      </Components.Tooltip>
    </>
  );
};

export default SelectOrientation;
